import * as React from 'react'
import {
  MembershipSectionContainer,
  MembershipSectionWrapper,
  MembershipContentWrapper,
  MembershipSectionBlock,
  CallToActionButtonWrapper,
  MembershipSectionText,
  ListParagraph
} from './MembershipSection.elements'

import { Button, LinkWhiteHoverUnderlineButton} from '@components/Button';
import { IconList } from '@components/IconList';

export type MembershipSectionProps = {
  type: string
  title: string
  subtitle: string
  contentTitle: string
  termsTitle: string
  buttonText: string
  secondButtonText: string
}

import {
  VitaminsIcon,
  WatchIcon,
  OrthoticsIcon,
  MassageIcon,
  GlassesIcon,
  CaretRightIcon,
  IconWrapper
} from "@components/Icons";

const goToSignup = () => {
  window.location.href = '/signup';
};

const goToMembershipPage = () => {
  window.location.href = '/membership';
};

const wrapIcon = (icon: JSX.Element, padding?: string) => {
  return (
    <IconWrapper padding={padding}>{icon}</IconWrapper>
  );
}

const iconsFirstColumn = [<VitaminsIcon />, <WatchIcon />, <OrthoticsIcon />]
const iconsSecondColumn = [<MassageIcon />, <GlassesIcon />]
const iconsPaddingSecondColumn = ['3.5px 0', '12px 0'];
const introItems = ['Vitamins', 'Smart Watches', 'Orthotics', 'Massage', 'Eyeglasses'];
const dataFirstColumn = introItems.slice(0, 3)
  .map((text, i) => ({ text, icon: wrapIcon(iconsFirstColumn[i]) }))

const dataSecondColumn = introItems.slice(3, 5)
  .map((text, i) => ({ text, icon: wrapIcon(iconsSecondColumn[i], iconsPaddingSecondColumn[i]) }))

export const MembershipSection: React.FunctionComponent<MembershipSectionProps> = (
  {
    title,
    subtitle,
    contentTitle,
    termsTitle,
    buttonText,
    secondButtonText
  }) => (
  <MembershipSectionContainer>
    <MembershipSectionWrapper>
      <MembershipContentWrapper>
        <MembershipSectionBlock>
          <MembershipSectionText bold={true}>
            <h1>{title}</h1>

            <p>{subtitle}</p>
          </MembershipSectionText>

          <CallToActionButtonWrapper>
            <Button variant="dark-blue" onClick={goToSignup}>{buttonText}</Button>
          </CallToActionButtonWrapper>

          <CallToActionButtonWrapper buttonFullWidth={true} desktopOnly={true}>
            <LinkWhiteHoverUnderlineButton onClick={goToMembershipPage}>
              {secondButtonText} <CaretRightIcon />

            </LinkWhiteHoverUnderlineButton>
          </CallToActionButtonWrapper>
        </MembershipSectionBlock>

        <MembershipSectionBlock center={true}>
          <MembershipSectionText bold={true}>
            <h3>{contentTitle}</h3>
          </MembershipSectionText>

          <hr/>

          <MembershipSectionWrapper paddingHorizontal='0' forceHorizontalLayout={true}>
            <MembershipSectionBlock center={true} paddingHorizontal='0'>
              <IconList
                data={dataFirstColumn}
                fontSize={20}
                fontSizeMobile={16}
                minWidth={'80%'}
                marginLeftText={'52px'} />
            </MembershipSectionBlock>

            <MembershipSectionBlock center={true} paddingHorizontal='0'>
              <IconList data={dataSecondColumn} fontSize={20} fontSizeMobile={16} minWidth={'80%'} marginLeftText={'52px'} />

              <ListParagraph>...and More!</ListParagraph>
            </MembershipSectionBlock>
          </MembershipSectionWrapper>

          <MembershipSectionText>
            <span>{termsTitle}</span>
          </MembershipSectionText>

          <CallToActionButtonWrapper mobileOnly={true}>
            <LinkWhiteHoverUnderlineButton onClick={goToMembershipPage}>
              {secondButtonText}
            </LinkWhiteHoverUnderlineButton>
          </CallToActionButtonWrapper>

        </MembershipSectionBlock>
      </MembershipContentWrapper>
    </MembershipSectionWrapper>
  </MembershipSectionContainer>
)
